export { Label, type LabelProps } from './Label';
export { labelVariants, type LabelVariantProps } from './label.variants';
